import type { UnknownError } from '@cian/peperrors/shared';

import { EQueryKeys } from 'shared/store/serverSide/EQueryKeys';

export type QueryError = UnknownError;

export type QueryKey = [EQueryKeys.MonolithCianRealty__Api_Geo_GeocodeCached];
export const getQueryKey = (): QueryKey => [EQueryKeys.MonolithCianRealty__Api_Geo_GeocodeCached];
